// ============= Imports =============
import { SignalRContextProps } from '@/contexts/SignalRContext';

// ============= Constants =============
const HUB_NAME = 'userRelayHub';

// ============= Types =============
export interface SendMessageUserSessionProps {
  invokeHub: SignalRContextProps['invokeHub'];
  workspaceId: string;
  senderId: string;
  message: string;
}

// ============= Main Function =============
/**
 * Sends a message via UserMessageRelayHub
 * @param invokeHub Function to invoke SignalR hub methods
 * @param workspaceId The workspace ID
 * @param senderId The ID of the message sender
 * @param message The message content
 * @returns Promise with API response or error
 */
export const sendMessageUserSession = async ({
  invokeHub,
  workspaceId,
  senderId,
  message,
}: SendMessageUserSessionProps): Promise<any> => {
  try {
    console.log(
      `🔄 Sending message in workspace [${workspaceId}] via UserMessageRelayHub...`
    );

    if (!workspaceId) {
      throw new Error('workspaceId is required');
    }
    if (!senderId) {
      throw new Error('senderId is required');
    }
    if (!message) {
      throw new Error('message is required');
    }

    const result = await invokeHub<any>(
      HUB_NAME,
      'SendMessageAsync',
      workspaceId,
      senderId,
      message
    );

    console.log(`✅ Message sent successfully in workspace [${workspaceId}]`);
    return result;
  } catch (error) {
    console.error(
      `🔴 Error sending message in workspace [${workspaceId}] via UserMessageRelayHub:`,
      error
    );
    throw error;
  }
};
